import * as React from "react";
const SvgIcFlagFilled = props => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M6 23L6 15L6 13H14V15H10V18H23V6H17V3H6V1H3V3V15V23H6Z" fill="currentColor" /></svg>;
export default SvgIcFlagFilled;